<template>
  <div>
    <van-dialog v-model="DialogShow" title="添加合同信息" width="95%" style="height:80%" class="editClue"  :beforeClose="beforeClose" show-cancel-button>
      <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-cell-group>
          <van-field v-model="form.contractName" label="合同标题" placeholder="请输入合同标题" :rules="[{ required: true }]" required />
          <van-field v-model="form.contractNum" label="合同编号" placeholder="请输入合同编号" :rules="[{ required: true}]" required />
          <van-field readonly clickable v-model="form.boName" placeholder="请选择商机名称" @click="showPicker('boId')" label="商机名称" required />
          <van-field v-model="form.custName" label="客户名称" placeholder="请选择商机名称" :rules="[{ required: true }]" readonly required />
          <van-field v-model="form.contractMoney" label="合同金额" placeholder="请输入合同金额" :rules="[{ required: true }]" required />
          <van-field v-model="form.allReturnedMoney" label="合同回款总金额" placeholder="请输入合同回款总金额" label-width="120px" :rules="[{ required: true }]" required />
          <van-field v-model="form.noReturnedMoney" label="合同未回款金额"  placeholder="请输入合同未回款金额" label-width="120px" :rules="[{ required: true }]" required />
          <!-- <van-field readonly clickable v-model="form.contractTypeName" @click="showPicker('contractType')" label="合同类型" required /> -->
          <van-field readonly clickable v-model="form.contractStatusName" placeholder="请选择合同状态" @click="showPicker('contractStatus')" label="合同状态" />
          <van-field readonly clickable v-model="form.payModeName" placeholder="请选择支付方式" @click="showPicker('payMode')" label="支付方式" required />
          <van-field v-model="form.startTime" readonly clickable name="calendar" label="开始时间" placeholder="点击选择日期" @click="showStartCalendar = true" required />
          <van-field v-model="form.endTime" readonly clickable name="calendar" label="结束时间" placeholder="点击选择日期" @click="showEndCalendar = true" required />
          <van-field v-model="form.signTime" readonly clickable name="calendar" label="签约日期" placeholder="点击选择日期" @click="showSignCalendar = true" required />
          <van-field v-model="form.custSignedUser" label="对方签约人" :rules="[{ required: true }]" required />
          <van-field v-model="form.mySignedUser" label="我方签约人" :rules="[{ required: true}]" required />
          <!-- <van-field name="rate" label="电子合同">
            <template #input>
              <van-uploader v-model="fileList" :after-read="uploadContractFiles" :max-count="1" :max-size="52428800" upload-text="电子合同" required>
              </van-uploader>
            </template>
          </van-field>
          <van-field name="rate" label="附件1">
            <template #input>
              <van-uploader v-model="fileList1" :after-read="uploadContractFiles1" :max-count="1" :max-size="52428800" upload-text="附件1">
              </van-uploader>
            </template>
          </van-field>
          <van-field name="rate" label="附件2">
            <template #input>
              <van-uploader v-model="fileList2" :after-read="uploadContractFiles2" :max-count="1" :max-size="52428800" upload-text="附件2">
              </van-uploader>
            </template>
          </van-field> -->
          <van-field v-model="form.remark" label="备注" />
          <van-field v-model="form.content" rows="2" type="textarea" label="合同内容" />
        </van-cell-group>
      </van-form>
    </van-dialog>
    <!-- 日期选择器 -->
    <van-calendar v-model="showStartCalendar" :min-date="minDate" type="single" @confirm="onStartCalendarConfirm" />
    <van-calendar v-model="showEndCalendar" :min-date="minDateStart" type="single" @confirm="onEndCalendarConfirm" />
    <van-calendar v-model="showSignCalendar" :min-date="minDate" type="single" @confirm="onSignCalendarConfirm" />
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>
  </div>
</template>
<script>
import { ucloudUpFileToContract } from "@/api/system/common";
import {listBo} from "@/api/scrm/mycust";

export default {
  name: 'DialogContract',
  components: {
  },
  props: {
    show: Boolean,
    contractType: Number,
  },
  watch: {
    show: {
      handler(val, oldVal) {
        this.DialogShow = val
      }
    },
    contractType: {
      handler(val, oldVal) {
        this.form.contractType = val
      }
    },
  },
  data() {
    return {
      DialogShow: this.show,
      picker: {
        visible: false,
        title: "",
        columns: [],
        formKey: "",
      },
      //商机数据
      custBoList:[],
      queryBoParams: {
      },
      // 合同类型
      contractTypeOptions: this.$store.state.dictOptions.contractType || [],
      // 合同状态
      contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      // 支付方式
      payModeOptions: this.$store.state.dictOptions.payMode || [], 

      fileList: [],
      total: 0,
      fileList1: [],
      fileList2: [],
      form: {
        contractId: null,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: this.contractType,
        contractStatus: null,
        payMode: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        startTime: null,
        endTime: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null,
      },
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      showStartCalendar: false,
      showEndCalendar: false,
      showSignCalendar: false,
    }
  },
  methods: {
    formatDate(date) {
      // 时间格式化 2019-09-08
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return year + "-" + month + "-" + day;
    },
    onStartCalendarConfirm(data) {
      this.form.startTime = this.formatDate(data);
      this.showStartCalendar = false;
      this.minDateStart = data
    },
    onEndCalendarConfirm(data) {
      this.form.endTime = this.formatDate(data);
      this.showEndCalendar = false;
    },
    onSignCalendarConfirm(data) {
      this.form.signTime = this.formatDate(data);
      this.showSignCalendar = false;
    },
    async beforeClose(type, done) {
      if (type === "confirm") {
        try {
          await this.$refs["form"].validate();
          this.$emit('beforeClose', this.form)
          done();
        } catch (err) {
          return done(false);
        }
        return done(false);
      }else{
          done();
          this.$emit('handleAddContractCancel')
      } 
    },
    showPicker(type) {
      this.picker.formKey = type;
      if (type === "contractType") {
        this.picker.columns = this.contractTypeOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "contractStatus") {
        this.picker.columns = this.contractStatusOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "payMode") {
        this.picker.columns = this.payModeOptions.map((ele) => ele.dictLabel);
      }
      //选择商机
      if(type === "boId"){  
        listBo(this.queryBoParams).then(response => {
          this.custBoList = response.rows; 
          this.picker.columns = this.custBoList.map(item => item.boName + "(" + item.custName + ")");
        }); 
      }
      this.picker.visible = true;
    },
    pickerConfirm(value, index) {
      if (this.picker.formKey === "contractType") {
        this.form.contractType = this.contractTypeOptions[index].dictValue;
        this.form.contractTypeName = this.contractTypeOptions[index].dictLabel;
      }
      if (this.picker.formKey === "contractStatus") {
        this.form.contractStatus = this.contractStatusOptions[index].dictValue;
        this.form.contractStatusName =
          this.contractStatusOptions[index].dictLabel;
      }
      if (this.picker.formKey === "payMode") {
        this.form.payMode = this.payModeOptions[index].dictValue;
        this.form.payModeName = this.payModeOptions[index].dictLabel;
      }
      //选择商机
      if (this.picker.formKey === "boId"){  
        this.form.boId = this.custBoList[index].boId;
        this.form.boName = this.custBoList[index].boName;
        this.form.custId = this.custBoList[index].custId;
        this.form.custName = this.custBoList[index].custName;
      }
      this.picker.visible = false;
    },

    pickerCancel() {
      this.picker.visible = false;
    },
    uploadContractFiles(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          if (res.code === 200) {
            this.form.contractFile = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles1(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          if (res.code === 200) {
            this.form.annexOne = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles2(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          if (res.code === 200) {
            this.form.annexTwo = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },

}
</script>
<style lang="less" scoped>
.editClue /deep/.van-dialog__content {
  height: 80%;
}
</style>